import { Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';

const SwitchButton = (props) => {
  const [switchTab, setSwitchTab] = useState(props.right ? true : false);
  // console.log(
  //   'switchTab',
  //   props.right,
  //   typeof props.right === Boolean,
  //   switchTab
  // );
  const handleSwitch = () => {
    const updatedState = !switchTab;
    setSwitchTab(updatedState);
    props.handleSwitchButton(updatedState);
  };

  useEffect(() => {
    if (props?.right !== undefined) {
      if (typeof props.right === Boolean) {
        setSwitchTab(props?.right);
      } else {
        setSwitchTab(props?.right === 'ht' ? false : true);
      }
    }
  }, [props?.right]);
  return (
    <div className='inline-flex items-center mr-[33px] mb-[20px] min-[601px]:absolute min-[601px]:bottom-0 min-[601px]:right-[-17px] max-[600px]:mt-[10px]'>
      <div className='flex p-[3px] text-white text-[13px] font-[600] bg-[#0F59F9] rounded-[4px] relative'>
        <span className='inline-block py-[3px] px-[10px]'>LT</span>
        <span className='inline-block py-[3px] px-[10px]'>HT</span>
        <span
          className={`cursor-pointer switch_wt_bx absolute top-[50%] -translate-y-[50%] ${
            switchTab ? 'right-[3px]' : 'right-[53%]'
          } h-[85%] w-[44%] bg-white rounded-[4px]`}
          onClick={handleSwitch}
        ></span>
      </div>
      <Tooltip title='coming soon'>
        <img src='/images/fi_info.svg' alt='info' className='ml-[10px]' />
      </Tooltip>
    </div>
  );
};

export default SwitchButton;
